import React from "react";
import TabbedTable from "../../Components/NutritionTable/TabbedTable";

const VoedingPage = () => {
  return <TabbedTable />;
};

export default VoedingPage;
